import { Component, OnDestroy, OnInit } from "@angular/core";

import { EventsService } from "../../_services/eventsServices/events.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { RowEventTypeEmit } from "../events-screen/event-page-models/row-event-type-emit";
import { ParentEventMessageType } from "../events-screen/event-page-models/parent-event-message";
import { EventsTypesManagementService } from "../../_services/events-management.service";
import { EventTypeData } from "../../_models/event-type-data";
import { DataService } from "../../_services/data.service";

@Component({
  selector: "event-type-management-screen",
  templateUrl: "./event-type-management-screen.component.html",
  styleUrls: [
    "../events-screen/parent-events-page/parent-events-page.component.scss",
    "./event-type-management-screen.component.scss",
  ],
})
export class EventTypeManagementScreenComponent implements OnInit, OnDestroy {
  public readonly $eventsTypes: BehaviorSubject<EventTypeData[]> =
    new BehaviorSubject<EventTypeData[]>([]);
  public readonly $eventTypeIdInEdit: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);
  public readonly newEventId = -1;

  public circleNames: string[] = [];
  public newEventType: EventTypeData = {
    defaultIndex: null,
    name: "",
    id: this.newEventId.toString(),
    isMultiday: false,
    indexes: [],
    isVisible: false,
  };

  constructor(
    private eventsService: EventsService,
    private eventsManagementService: EventsTypesManagementService,
    private modalService: NgbModal,
    private router: Router,
    private dataService: DataService,
    private sessionManager: SessionManagerService
  ) {
    this.getEventsTypesEvents().then();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public async rowEventHandler($event: RowEventTypeEmit) {
    switch ($event.action) {
      case "startEdit":
        this.$eventTypeIdInEdit.next(+$event.eventTypeId);
        break;
      case "save":
        const saveResult = await this.eventsManagementService.saveEventType(
          $event.data
        );
        if (saveResult.success) {
          this.eventsService.setParentEventMessage({
            text: `הארוע ${$event.data.name} נשמר בהצלחה`,
            type: ParentEventMessageType.Info,
          });
          const allEventTypes =
            await this.eventsManagementService.getAllEventTypes();
          this.$eventsTypes.next(allEventTypes);
          this.$eventTypeIdInEdit.next(0);
        } else {
          this.eventsService.setParentEventMessage({
            text: `השמירה נכשלה, אנא פנו לתמיכה`,
            type: ParentEventMessageType.Info,
          });
          this.$eventTypeIdInEdit.next(0);
        }

        break;
      case "cancelEdit":
        this.$eventTypeIdInEdit.next(0);
        break;
    }
  }

  public addNewEvent() {
    this.$eventTypeIdInEdit.next(this.newEventId);
  }

  public backToSystemManagement() {
    this.router.navigate(["/admin"]).then();
  }

  private async getEventsTypesEvents(): Promise<void> {
    const allEventTypes = await this.eventsManagementService.getAllEventTypes();
    this.circleNames =
      allEventTypes[0].indexes.map((evIndex) => evIndex.circleName) || [];

    this.newEventType.indexes = allEventTypes[0].indexes.map((evIndex) => ({
      ...evIndex,
      id: "-1",
      eventId: this.newEventType.id,
      value: null,
    }));
    this.$eventsTypes.next(allEventTypes);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/event-type-management/event-type-management-screen.component.ts